export default __webpack_public_path__ + "static/media/Newsletter 002.1147d291.png";